import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { CalendarDaysIcon, CheckCircle2Icon, HomeIcon, MessageCircleIcon } from 'lucide-react';
import { useDatabase } from '../hooks/useDatabase';
import { usePublicLanding } from '../hooks/usePublicContent';
import { Button } from '../components/ui/Button';
import { BrandLogo } from '../components/shared/BrandLogo';
import { ThankYouConfig } from '../types';
const FALLBACK: ThankYouConfig = {
  title: 'Hemos recibido tu solicitud.',
  text: 'Nuestro equipo se pondrá en contacto contigo lo antes posible.',
  showCalendly: false,
  showWhatsapp: false,
  showHome: true
};

/** Página de agradecimiento configurable por landing: /gracias/:slug */
export function ThankYou() {
  const {
    slug = ''
  } = useParams();
  const db = useDatabase();
  usePublicLanding(slug);
  const landing = db.landings.find(l => l.slug === slug);
  const organization = landing ? db.organizations.find(o => o.id === landing.organizationId) : undefined;
  const logoUrl = landing?.pageConfig.logoUrl ?? organization?.brand.logoUrl ?? organization?.logoUrl;
  const config = landing?.pageConfig.thankYou ?? FALLBACK;
  useEffect(() => {
    if (!config.autoRedirectUrl) return;
    const timer = setTimeout(() => {
      window.location.href = config.autoRedirectUrl as string;
    }, 4000);
    return () => clearTimeout(timer);
  }, [config.autoRedirectUrl]);
  return <main className="flex min-h-screen w-full items-center justify-center bg-surface px-5 py-16" style={landing ? {
    '--primary': landing.pageConfig.primaryColor
  } as React.CSSProperties : undefined} data-id="element-1496" data-mp="2qvvqis3l43yo">
      <div className="w-full max-w-xl rounded-lg border border-border bg-background p-8 text-center shadow-md sm:p-12" data-id="element-1497" data-mp="2d5in931n1dfo">
        <div className="mb-8 flex justify-center" data-id="element-1498" data-mp="39nwxyiufd2jp">
          <BrandLogo src={logoUrl} size={28} data-id="element-1499" data-mp="34w6mg9jr48qp" />
        </div>
        <span className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10" data-id="element-1500" data-mp="34ulrwjxfspsu">
          <CheckCircle2Icon className="h-7 w-7 text-primary" aria-hidden="true" data-id="element-1501" data-mp="12zei9e8ln5k1" />
        </span>
        <h1 className="text-2xl font-semibold text-navy sm:text-3xl" data-id="element-1502" data-mp="17wxxagd4fmd1">
          {config.title}
        </h1>
        <p className="mx-auto mt-4 max-w-md text-base leading-relaxed text-muted-foreground" data-id="element-1503" data-mp="t6qo6r907fp0">
          {config.text}
        </p>

        {config.imageUrl && <img src={config.imageUrl} alt="" className="mx-auto mt-8 w-full rounded-lg object-cover" data-id="element-1504" data-mp="k73jnwkz9trq" />}

        <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:justify-center" data-id="element-1505" data-mp="a9yxhwr4tyax">
          {config.showCalendly && <Button leftIcon={<CalendarDaysIcon className="h-4 w-4" data-id="element-1507" data-mp="f9toe0awqnvz" />} onClick={() => {
          if (config.calendlyUrl) window.open(config.calendlyUrl, '_blank', 'noopener');
        }} data-id="element-1506" data-mp="f8il01ldji5e">
              Agendar una llamada
            </Button>}
          {config.showWhatsapp && <Button variant="secondary" leftIcon={<MessageCircleIcon className="h-4 w-4" data-id="element-1509" data-mp="3p7byd0vfq24z" />} onClick={() => {
          const number = (config.whatsappNumber || '').replace(/\D/g, '');
          if (number) window.open(`https://wa.me/${number}`, '_blank', 'noopener');
        }} data-id="element-1508" data-mp="3u2rc7stfzy1e">
              Hablar por WhatsApp
            </Button>}
          {config.showHome && <Link to="/" data-id="element-1510" data-mp="co2pi1w2hch1">
              <Button variant="ghost" leftIcon={<HomeIcon className="h-4 w-4" data-id="element-1512" data-mp="qox0msai1rje" />} data-id="element-1511" data-mp="cqoze86fk42f">
                Volver al inicio
              </Button>
            </Link>}
        </div>
      </div>
    </main>;
}